import { render, staticRenderFns } from "./singleDetails.vue?vue&type=template&id=25bad7a9&scoped=true&"
import script from "./singleDetails.vue?vue&type=script&lang=js&"
export * from "./singleDetails.vue?vue&type=script&lang=js&"
import style0 from "./singleDetails.vue?vue&type=style&index=0&id=25bad7a9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bad7a9",
  null
  
)

export default component.exports